<!--
포장방법 신청안함(작업자임의) 안내 라벨 컴포넌트
---------------------------------------

-->
<template>
    <div class="uk-inline uk-position-relative">
        <!-- 라벨 -->
        <span class="uk-label uk-label-border-dark" @mouseenter="openView" @mouseleave="closeView">
            포장방법이란?
        </span>

        <!-- 팝업 -->
        <div class="popup" :class="popupDirection" v-show="viewDisplay">
            [신청안함(작업자임의)] 선택시:<br />
            작업자 판단에 의해 폴리백 또는 박스포장 됩니다.
            <br /><br />

            [폴리백포장] 선택시:<br />
            폴리백 포장되며 부피청구 하지 않습니다.
            <br /><br />

            [신청안함(작업자임의)] 선택시:<br />
            박스포장하며, 부피청구 합니다.<br />
            고가이거나 박스포장이 필요한 경우는 반드시 [박스포장] 선택 바랍니다.
            <br /><br />

            * 그러나 파손이 우려되는 상품의 경우, 선택사항과 무관하게 작업자 판단에 의해 박스포장 후 부피청구 할 수 있습니다.
            <br /><br />

            * 박스포장의 경우 대부분 재활용박스가 사용되며, 박스비용이 청구되지 않습니다.<br />
            소형 및 파손우려제품(시계, CAP모자, 약품등..)은 전용 새박스를 사용하며, 박스비용이 청구됩니다.
            <br /><br />

            [버블봉투] 선택시:<br />
            버블봉투(안쪽에 완충제 부착된 종이봉투)를 사용하여 포장하며, 부피청구 하지 않습니다.
            <br /><br />

            * 파손우려가 없는 소형 약품에 적합합니다.  유리병 제품은 [버블봉투] 선택하시면 안됩니다.<br />
            * 소형 약품 2병 정도만 포장 가능합니다. (버블봉투 사이즈가 크지 않습니다)<br />
            * 버블봉투 비용이 추가됩니다.
            <br /><br />

            * 포장방법과 관련된 문의는 상품상세 > 우측탭 하단 > [고객문의]로 문의해주시기 바랍니다.
            <br /><br />

        </div>
    </div>

</template>

<script>
    import Base from './base.vue';

    export default {
        extends: Base,
    }
</script>

<style lang="scss" scoped>
    @import './base';
</style>